// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__2Cj13","consentsList":"PatientConsents_consentsList__2Qjaw","consentsListEmpty":"PatientConsents_consentsListEmpty__115Rc"};